export default __webpack_public_path__ + "static/media/tylerbig.31bf9355.png";